import { styled } from '@mui/material/styles';
import { css } from '@emotion/react';
import { scrollbar } from 'utils';

export const StyledResourceCategoryFilter = styled('div')(
  () => css`
    .filter-resource-tag {
      position: relative;
      ul {
        list-style: none;
        padding: 0;
        margin: 0;
        top: 48px;
        right: 0;
        left: 0;
        max-height: 290px;
        overflow: auto;
        overflow-x: hidden;
        background-color: white;
        border: 1px solid #eeeeee;
        box-sizing: border-box;
        border-radius: 6px;
        z-index: 1;
        padding: 0 16px;
        ${scrollbar(0)};
        &:hover {
          ${scrollbar(0, '#9b9ea0')};
        }
        .loading-section {
          padding: 20px 0;
        }
        li {
          cursor: pointer;
          padding: 8px 0;
          border-bottom: 1px solid #e4e9ec;
          label {
            display: block;
            font-size: 0.875rem;
            cursor: pointer;
          }
          &:last-child {
            border-bottom: none;
          }
          &.selected {
            * {
              opacity: 0.3;
            }
            cursor: not-allowed;
            label {
              cursor: not-allowed;
            }
          }
        }
      }
      .search-icon {
        margin-right: 15px;
      }
      .selected-resource-tags {
        padding: 12px 10px;
        box-sizing: border-box;
        margin: 8px 0 16px 0;
        background: #f9f9f9;
        border: 1px solid #f5f5f5;
        box-sizing: border-box;
        border-radius: 8px;
        .resource-tag {
          background-color: #e1e8ff;
          padding: 8px 12px;
          border-radius: 6px;
          color: #6c879b;
          font-size: 0.75rem;
          .icon {
            margin-right: 10px;
            width: 17px;
            cursor: pointer;
          }
        }
      }
    }
  `
);
